<template>
	<div class="menu">
		<p class="logo">
			<img src='../../assets/img/icon/logo.jpg' />
		</p>

		<div class="menus" :class="{'active':$route.path.indexOf('home')>-1}" @click="menuItemClick('/home')">
			<img src="@/assets/img/icon/shouye.svg" /> 首页
		</div>

		<div v-if="$store.state.user.UserType<3" @click='borrowAndReturn=!borrowAndReturn' class="menus">
			<img src="@/assets/img/icon/reback.svg" /> 门店业务

			<img style="margin-left: 3rem;" v-show="!borrowAndReturn" src="@/assets/img/icon/right.svg" />
			<img style="margin-left: 3rem;" v-show="borrowAndReturn" src="@/assets/img/icon/down.svg" />
		</div>


		<div v-show="borrowAndReturn" v-if="$store.state.user.UserType<3" class="menuItem"
			@click="menuItemClick('/borrowBooks')" :class="{'active': $route.path.indexOf('borrowBooks')>-1}">
			会员借书
		</div>
		<div v-show="borrowAndReturn" v-if="$store.state.user.UserType<3" class="menuItem"
			@click="menuItemClick('/returnBooks')"
			:class="{'active': $route.path.indexOf('returnBooks')>-1 && $route.path.indexOf('weChat')==-1  }">
			会员还书
		</div>

		<div v-show="borrowAndReturn" v-if="$store.state.user.UserType<3" class="menuItem"
			@click="menuItemClick('/sellbooks')"
			:class="{'active': $route.path.indexOf('sellbooks')>-1 && $route.path.indexOf('weChat')==-1  }">
			书籍售出
		</div>

		<div v-show="borrowAndReturn" v-if="$store.state.user.UserType<2" class="menuItem"
			@click="menuItemClick('/abnormal')" :class="{'active': $route.path.indexOf('abnormal')>-1   }">
			异常还书
		</div>

		<div v-if="$store.state.user.UserType<=2 && $store.state.user.ShopType<=2" @click='weChat=!weChat'
			class="menus">
			<img src="@/assets/img/icon/weChat.svg" /> 微信订单

			<img style="margin-left: 3rem;" v-show="!weChat" src="@/assets/img/icon/right.svg" />
			<img style="margin-left: 3rem;" v-show="weChat" src="@/assets/img/icon/down.svg" />
		</div>
		<div v-show="weChat" v-if="$store.state.user.UserType<=2 && $store.state.user.ShopType<=1" class="menuItem"
			@click="menuItemClick('/weChat/borrowOrder')"
			:class="{'active': $route.path.indexOf('/weChat/borrowOrder')>-1}">
			借书单-待处理
		</div>
		<div v-show="weChat" v-if="$store.state.user.UserType<=2 && $store.state.user.ShopType<=2" class="menuItem"
			@click="menuItemClick('/weChat/returnOrder')"
			:class="{'active': $route.path.indexOf('/weChat/returnOrder')>-1}">
			还书单-待处理
		</div>

		<div v-show="weChat" v-if="$store.state.user.UserType<=2 && $store.state.user.ShopType<=2" class="menuItem"
			@click="menuItemClick('/weChat/transportOrder')"
			:class="{'active': $route.path.indexOf('/weChat/transportOrder')>-1}">
			订单-配送中
		</div>

		<div v-show="weChat" v-if="$store.state.user.UserType<=2 && $store.state.user.ShopType<=2" class="menuItem"
			@click="menuItemClick('/weChat/returnBooks')"
			:class="{'active': $route.path.indexOf('/weChat/returnBooks')>-1}">
			还书单-还书
		</div>

		<div v-if="$store.state.user.IsSubject==0 && $store.state.user.UserType<=2" @click='IsSubject=!IsSubject'
			class="menus">
			<img src="@/assets/img/icon/subject.svg" /> 体 验 课&nbsp;

			<img style="margin-left: 3rem;" v-show="!IsSubject" src="@/assets/img/icon/right.svg" />
			<img style="margin-left: 3rem;" v-show="IsSubject" src="@/assets/img/icon/down.svg" />
		</div>

		<div v-if="$store.state.user.UserType==0" v-show="IsSubject" class="menuItem"
			@click="menuItemClick('/subjectSet')" :class="{'active':$route.path.indexOf('subjectSet')>-1 }">
			课程设置
		</div>

		<div v-if="$store.state.user.UserType<=2" v-show="IsSubject" class="menuItem"
			@click="menuItemClick('/shopSubject')" :class="{'active':$route.path.indexOf('shopSubject')>-1 }">
			店铺排课
		</div>

		<div v-if="$store.state.user.UserType<=2" v-show="IsSubject" class="menuItem"
			@click="menuItemClick('/SubjectSignUp')" :class="{'active':$route.path.indexOf('SubjectSignUp')>-1 }">
			课程报名
		</div>

		<div v-if="$store.state.user.UserType<=2 && $store.state.user.ShopType<=1" v-show="IsSubject" class="menuItem"
			@click="menuItemClick('/subjectFeedback')" :class="{'active':$route.path.indexOf('subjectFeedback')>-1 }">
			课程反馈
		</div>




		<div v-if="$store.state.user.UserType<=1 && $store.state.user.ShopType<=1" @click='shop=!shop' class="menus">
			<img src="@/assets/img/icon/reback.svg" /> 店铺管理

			<img style="margin-left: 3rem;" v-show="!shop" src="@/assets/img/icon/right.svg" />
			<img style="margin-left: 3rem;" v-show="shop" src="@/assets/img/icon/down.svg" />
		</div>

		<div v-if="$store.state.user.UserType==0" v-show="shop" class="menuItem" @click="menuItemClick('/AreaMangment')"
			:class="{'active':$route.path.indexOf('AreaMangment')>-1 }">
			地区管理
		</div>

		<div v-if="$store.state.user.UserType<=1 && $store.state.user.ShopType<=1" v-show="shop" class="menuItem"
			@click="menuItemClick('/ShopMangment')" :class="{'active':$route.path.indexOf('ShopMangment')>-1 }">
			店铺管理
		</div>



		<div v-if="$store.state.user.UserType<2" @click='users=!users' class="menus">
			<img src="@/assets/img/icon/users.svg" /> 员工管理

			<img style="margin-left: 3rem;" v-show="!users" src="@/assets/img/icon/right.svg" />
			<img style="margin-left: 3rem;" v-show="users" src="@/assets/img/icon/down.svg" />
		</div>
		<div v-if="$store.state.user.UserType<2" v-show="users" class="menuItem"
			@click="menuItemClick('/userMangement')" :class="{'active':$route.path.indexOf('userMangement')>-1 }">
			员工管理 </div>
		<div v-if="$store.state.user.UserType<2" v-show="users" class="menuItem"
			@click="menuItemClick('/signInHistory')" :class="{'active': $route.path.indexOf('signInHistory')>-1}">
			登录记录 </div>

		<div @click='books=!books' v-if="$store.state.user.UserType<=2" class="menus">
			<img src="@/assets/img/icon/book.svg" /> 图书管理
			<img style="margin-left: 3rem;" v-show="!books" src="@/assets/img/icon/right.svg" />
			<img style="margin-left: 3rem;" v-show="books" src="@/assets/img/icon/down.svg" />
		</div>

		<div v-show="books" v-if="$store.state.user.UserType<=1 && $store.state.user.ShopType==0" class="menuItem"
			@click="menuItemClick('/writer')" :class="{'active': $route.path.indexOf('writer')>-1}">
			书籍作者
		</div>
		<div v-show="books" v-if="$store.state.user.UserType<=1 && $store.state.user.ShopType==0" class="menuItem"
			@click="menuItemClick('/bookSeries')" :class="{'active': $route.path.indexOf('bookSeries')>-1}">
			书籍分类
		</div>
		<div v-show="books" v-if="$store.state.user.UserType<=2 && $store.state.user.ShopType<=2" class="menuItem"
			@click="menuItemClick('/bookMangment')" :class="{'active': $route.path.indexOf('bookMangment')>-1}">
			书籍归档
		</div>
		<div v-show="books" v-if="$store.state.user.UserType<=2 && $store.state.user.ShopType<=2" class="menuItem"
			@click="menuItemClick('/books')" :class="{'active': $route.path.indexOf('books')>-1}">
			图书管理
		</div>

		<div v-show="books" v-if="$store.state.user.UserType<=1 && $store.state.user.ShopType<=1" class="menuItem"
			@click="menuItemClick('/movebook')" :class="{'active': $route.path.indexOf('movebook')>-1}">
			图书调动
		</div>
		<div v-show="books" v-if="$store.state.user.UserType<=2" class="menuItem" @click="menuItemClick('/queryBook')"
			:class="{'active': $route.path.indexOf('queryBook')>-1}">
			图书查询
		</div>



		<div @click='customer=!customer' v-if="$store.state.user.UserType<=2" class="menus">
			<img src="@/assets/img/icon/customer.svg" /> 会员管理
			<img style="margin-left: 3rem;" v-show="!customer" src="@/assets/img/icon/right.svg" />
			<img style="margin-left: 3rem;" v-show="customer" src="@/assets/img/icon/down.svg" />
		</div>
		<div v-show="customer" v-if="$store.state.user.UserType<=1 && $store.state.user.ShopType==0" class="menuItem"
			@click="menuItemClick('/vipLevl')" :class="{'active': $route.path.indexOf('vipLevl')>-1}">
			设置会员
		</div>
		<div v-show="customer" v-if="$store.state.user.UserType<=2" class="menuItem"
			@click="menuItemClick('/newCustomers')" :class="{'active': $route.path.indexOf('newCustomers')>-1}">
			会员管理
		</div>

		<div v-show="customer" v-if="$store.state.user.UserType<=2" class="menuItem"
			@click="menuItemClick('/customerPayMoney')" :class="{'active': $route.path.indexOf('customerPayMoney')>-1}">
			会员缴费
		</div>

		<div v-show="customer" v-if="$store.state.user.UserType<=2" class="menuItem"
			@click="menuItemClick('/customerDeposit')" :class="{'active': $route.path.indexOf('customerDeposit')>-1}">
			押金管理
		</div>

		<div v-show="customer" v-if="$store.state.user.UserType<=2" class="menuItem"
			@click="menuItemClick('/customersRefund')" :class="{'active': $route.path.indexOf('customersRefund')>-1}">
			会员退费
		</div>

		<div v-if="$store.state.user.UserType<3" @click='query=!query' class="menus">
			<img src="@/assets/img/icon/order.svg" /> 历史查询
			<img style="margin-left: 3rem;" v-show="!order" src="@/assets/img/icon/right.svg" />
			<img style="margin-left: 3rem;" v-show="order" src="@/assets/img/icon/down.svg" />
		</div>
		<div v-if="$store.state.user.UserType<3" v-show="query" class="menuItem" @click="menuItemClick('/orderQuery')"
			:class="{'active':$route.path.indexOf('orderQuery')>-1 }">
			订单查询 </div>
		<div v-if="$store.state.user.UserType<2" v-show="query" class="menuItem"
			@click="menuItemClick('/customerQuery')" :class="{'active':$route.path.indexOf('customerQuery')>-1 }">
			客户查询 </div>
		<div v-if="$store.state.user.UserType<=1" v-show="query" class="menuItem" @click="menuItemClick('/queryMoney')"
			:class="{'active':$route.path.indexOf('queryMoney')>-1 }">
			收入查询 </div>

		<div v-if="$store.state.user.UserType<=2" v-show="query" class="menuItem" @click="menuItemClick('/queryDay')"
			:class="{'active':$route.path.indexOf('queryDay')>-1 }">
			未还书籍 </div>

		<div @click='system=!system' v-if="$store.state.user.UserType<=2" class="menus">
			<img src="@/assets/img/icon/system.svg" /> 系统设置
			<img style="margin-left: 3rem;" v-show="!system" src="@/assets/img/icon/right.svg" />
			<img style="margin-left: 3rem;" v-show="system" src="@/assets/img/icon/down.svg" />
		</div>
		<div v-show="system" v-if="$store.state.user.UserType<=2" class="menuItem"
			@click="menuItemClick('/changePassWorld')" :class="{'active': $route.path.indexOf('changePassWorld')>-1}">
			修改密码
		</div>


	</div>

</template>

<script>
	export default {
		name: 'webmenu',
		data() {
			return {
				path: '',
				users: false,
				index: 0,
				books: false,
				customer: false,
				borrowAndReturn: false,
				weChat: false,
				order: false,
				query: false,
				system: false,
				shop: false,
				IsSubject: false

			}
		},
		methods: {

			menuItemClick(path) {

				if (path != '') {
					this.$router.replace(path);
				}



			}
		}
	}
</script>

<style>
	.logo {
		text-align: center;
		color: #acacac;
		padding: .5rem 0rem;
		font-size: 1.5rem;
	}

	.logo img {
		height: 4rem;
		height: 4rem;
		border-radius: 50%;
	}

	.menu {
		position: fixed;
		left: 0rem;
		top: 0rem;
		width: 15rem;
		height: 100vh;
		background-color: #f1f1f1;
		box-shadow: 0 0 1rem rgba(253, 253, 253, 1.0);
		border-radius: 5px;
	}

	.menu div img {
		width: 1rem;
		height: 1rem;
		vertical-align: middle;
		line-height: 1.5rem;
	}

	.menu div {
		transition: all .5s;
		background-color: #7ab3c7;

		cursor: pointer;
		color: white;
		margin-top: .1rem;
	}

	.menu div:hover {
		background-color: #1c79bf;
	}

	.menus {
		padding: .5rem 1rem;
	}

	.menuItem {
		padding: .5rem 3.2rem;

	}

	.active {
		background-color: #4a9deb !important;
	}
</style>
